import "core-js/modules/es6.number.constructor";
var moment = require('moment');

/**
 * 时间过滤器
 * @param val，int时间戳
 * @return string，时间格式字符串
 */
export function filterTime(val) {
  if (val) {
    var date = new Date(Number(val) * 1000);
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
  } else if (val === 0) {
    return '';
  } else {
    return val;
  }
}
export function filterSize(val) {
  if (val) {
    return (val / (1024 * 1024)).toFixed(2) + 'MB';
  } else if (val === 0) {
    return '';
  } else {
    return val;
  }
}